import axios from 'axios';

import { IModelAParameter } from '@/shared/model/model-a-parameter.model';

const baseApiUrl = 'api/model-a-parameters';

export default class ModelAParameterService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IModelAParameter): Promise<IModelAParameter> {
    return new Promise<IModelAParameter>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public reset(parameterId: number): Promise<IModelAParameter> {
    return new Promise<IModelAParameter>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/reset/${parameterId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
